import React, { Component } from 'react';
import './PerfilMobiliarioMtoPrev.css';
import { esES } from '@mui/x-data-grid';
import {
  getmtosprevactivo,
  clearErrors,
  deleteMtoPreventivoActivo
} from '../../../redux/actions/mobiliarioactions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FaArrowLeft, FaFilePdf, FaTrash, FaCheckCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import MyButton from '../../../utils/MyButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import { IconButton, Stack, Tooltip } from '@mui/material';

export class PerfilMobiliarioMtoPrev extends Component {
  constructor() {
    super();
    this.state = {
      mtoid: '',
      errors: {},
      aprobado: {},
      opendelete: false
    };
  }

  componentDidMount() {
    this.props.getmtosprevactivo(this.props.mobiliarioId);
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    if (props.UI.errors) newState.errors = props.UI.errors;
    if (props.UI.aprobado) newState.aprobado = props.UI.aprobado;
    return Object.keys(newState).length > 0 ? newState : null;
  }

  handleOpenDelete = (rawdatamtoid) => {
    this.setState({ opendelete: true, mtoid: rawdatamtoid });
  };

  handleCloseDelete = () => {
    this.setState({ opendelete: false, errors: {}, aprobado: {} });
  };

  handleDelete = () => {
    const { credentials } = this.props.user;
    const handleUser = credentials.tipouser === 'Tecnico' ? credentials.handleuser : credentials.handle;
    this.props.deleteMtoPreventivoActivo(
      this.state.mtoid,
      this.props.mobiliarioId,
      this.props.clienteId,
      handleUser
    );
  };

  render() {
    const { mtosmobiliario, loadingmto } = this.props.dataMob;
    const {
      UI: { loading }
    } = this.props;

    const rows = mtosmobiliario.map((row, index) => ({
      id: row.mtoid || index,
      ...row
    }));

    const columns = [
        {
            field: 'acciones',
            headerName: 'Acciones',
            flex:1, minwidth:120,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
              <Stack direction="row" spacing={1}>
                <Tooltip title="Ver Reporte PDF">
                  <IconButton
                    size="small"
                    color="primary"
                    component={Link}
                    to={`/dashboard/perfilcliente/mobiliario/${this.props.clienteId}/${this.props.mobiliarioId}/reportepdf/${params.row.mtoid}`}
                  >
                    <FaFilePdf size={16} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Borrar Mantenimiento">
                  <IconButton
                    size="small"
                    color="#d7d7d7"
                    onClick={() => this.handleOpenDelete(params.row.mtoid)}
                  >
                    <FaTrash size={16} />
                  </IconButton>
                </Tooltip>
              </Stack>
            )
          },
      { field: 'fecha', headerName: 'Fecha', flex:1, minwidth:120},
      { field: 'horainicio', headerName: 'Hora Inicio', flex:1, minwidth:120},
      { field: 'horafinal', headerName: 'Hora Final', flex:1, minwidth:120 },
      {
        field: 'aprobado',
        headerName: 'Aprobado',
       flex:1, minwidth:120,
        renderCell: (params) => (params.value === true ? 'Sí' : 'No')
      },
    
    ];

    return (
      <div className="listamtoprog-container">
        <div className="listamtoprog-table">
          {!loadingmto ? (
            <div style={{ height: 500, width: '100%' }}>
              <DataGrid
                rows={rows}
                columns={columns}
                autoHeight
                pageSize={5}
                rowsPerPageOptions={[5, 10, 20]}
                disableRowSelectionOnClick
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                sx={{
                    borderRadius: 2,
                    backgroundColor: '#fff',
                    boxShadow: 3,
                    '& .MuiDataGrid-cell': {
                      fontSize: 14,
                    },
                    '& .MuiDataGrid-columnHeaders': {
                      backgroundColor: '#0588FB',
                      color: '#fff',
                      fontWeight: 'bold',
                      fontSize: 15,
                    },
                    '& .MuiDataGrid-row:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                }}
              />
            </div>
          ) : (
            <div className="div_cargando">
              <CircularProgress size={50} color="primary" className="login-progress" />
            </div>
          )}
        </div>

        <Dialog open={this.state.opendelete} onClose={this.handleCloseDelete} fullWidth maxWidth="sm">
          {this.state.aprobado.mensaje ? (
            <div className="div-aprobado">
              <div className="div-icono-delete">
                <FaTrash color="#ffffff" className="icono-aprobado" />
              </div>
              <h2 className="text-aprobado">Reporte Borrado Exitosamente</h2>
            </div>
          ) : (
            <DialogTitle>¿Estás seguro de borrar este Mantenimiento Preventivo?</DialogTitle>
          )}

          <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleCloseDelete}>
              <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
            </MyButton>
            {loading ? (
              <CircularProgress size={30} color="primary" className="login-progress" />
            ) : this.state.aprobado.mensaje ? (
              <MyButton tip="Continuar" onClick={this.handleCloseDelete}>
                <FaCheckCircle color="#f9044e" className="icon-formulario" />
              </MyButton>
            ) : (
              <MyButton tip="Borrar Mantenimiento" onClick={this.handleDelete}>
                <FaTrash color="#03178C" className="icon-formulario" />
              </MyButton>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

PerfilMobiliarioMtoPrev.propTypes = {
  getmtosprevactivo: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  deleteMtoPreventivoActivo: PropTypes.func.isRequired
};

const mapActionsToProps = {
  getmtosprevactivo,
  clearErrors,
  deleteMtoPreventivoActivo
};

const mapStateToProps = (state) => ({
  data: state.data,
  dataMob: state.dataMob,
  user: state.user,
  UI: state.UI
});

export default connect(mapStateToProps, mapActionsToProps)(PerfilMobiliarioMtoPrev);
